import React from 'react';
import Incompatible from '../../components/incompatible/Incompatible';

// eslint-disable-next-line react/jsx-props-no-spreading
const IncompatibleContainer = () => <Incompatible />;

export default IncompatibleContainer;
